import Image from "next/image";
import { LuBadgeCheck } from "react-icons/lu";

// Visual marker for LattuAI editorial articles. Compact (sm) for cards,
// expanded (md) for article header. Cyan matches the brand.
export function OfficialBadge({
  size = "sm",
  className = "",
}: {
  size?: "sm" | "md";
  className?: string;
}) {
  const sizing =
    size === "md" ? "px-2.5 py-1 text-xs gap-1.5" : "px-2 py-0.5 text-xs gap-1";
  const icon = size === "md" ? "w-3.5 h-3.5" : "w-3 h-3";
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold border bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-500/10 dark:text-cyan-300 dark:border-cyan-500/30 ${sizing} ${className}`}
      title="Official LattuAI article"
    >
      <LuBadgeCheck className={icon} />
      LattuAI · Official
    </span>
  );
}

// Tiny circular brand mark used next to author names on article cards.
// If the logo image fails to load, the cyan parent circle remains as the
// fallback mark — no broken-image icon.
export function LattuMark({
  size = 24,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  const imgSize = Math.round(size * 0.75);
  return (
    <span
      style={{ width: size, height: size }}
      className={`inline-flex items-center justify-center rounded-full bg-white dark:bg-black border border-gray-200 dark:border-white/15 overflow-hidden shrink-0 ${className}`}
      aria-label="LattuAI"
    >
      <Image
        src="/images/logo_b.svg"
        alt=""
        width={imgSize}
        height={imgSize}
        className="object-contain dark:hidden"
      />
      <Image
        src="/images/logo.svg"
        alt=""
        width={imgSize}
        height={imgSize}
        className="object-contain hidden dark:block"
      />
    </span>
  );
}
